// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ss-wrapper {
  position: relative;
  width: 100%;
}

.ss-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  background: var(--bg-input, #0f172a);
  border: 1px solid var(--border, #1e293b);
  border-radius: var(--radius-sm, 6px);
  cursor: pointer;
  min-height: 36px;
  font-size: 13px;
  color: var(--text-primary, #f0f2f5);
  transition: border-color 0.15s;
}

.ss-trigger:hover {
  border-color: var(--accent, #6366f1);
}

.ss-value {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ss-sublabel {
  font-size: 11px;
  color: var(--text-muted, #64748b);
  font-family: var(--font-mono, monospace);
}

.ss-placeholder {
  color: var(--text-muted, #64748b);
}

.ss-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

.ss-clear {
  background: none;
  border: none;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
  border-radius: 3px;
}

.ss-clear:hover {
  color: var(--danger, #ef4444);
  background: var(--bg-secondary, #1a2035);
}

.ss-chevron {
  color: var(--text-muted, #64748b);
  transition: transform 0.15s;
}

.ss-chevron.open {
  transform: rotate(180deg);
}

.ss-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: var(--bg-card, #1a2035);
  border: 1px solid var(--border, #1e293b);
  border-radius: var(--radius-sm, 6px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 1000;
  max-height: 320px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ss-search {
  position: relative;
  padding: 8px;
  border-bottom: 1px solid var(--border, #1e293b);
}

.ss-search-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted, #64748b);
}

.ss-search-input {
  width: 100%;
  padding: 6px 10px 6px 30px;
  background: var(--bg-input, #0f172a);
  border: 1px solid var(--border, #1e293b);
  border-radius: 4px;
  color: var(--text-primary, #f0f2f5);
  font-size: 12px;
  outline: none;
}

.ss-search-input:focus {
  border-color: var(--accent, #6366f1);
}

.ss-options {
  overflow-y: auto;
  max-height: 260px;
}

.ss-option {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 12px;
  color: var(--text-primary, #f0f2f5);
  border-bottom: 1px solid var(--border, #1e293b);
  transition: background 0.1s;
}

.ss-option:last-child {
  border-bottom: none;
}

.ss-option:hover {
  background: var(--bg-secondary, #0f172a);
}

.ss-option.selected {
  background: var(--accent-soft, rgba(99, 102, 241, 0.15));
  color: var(--accent, #6366f1);
}

.ss-option-empty {
  font-style: italic;
  color: var(--text-muted, #64748b);
}

.ss-option-label {
  font-weight: 500;
}

.ss-option-sublabel {
  font-size: 10px;
  color: var(--text-muted, #64748b);
  font-family: var(--font-mono, monospace);
  margin-top: 2px;
}

.ss-no-results {
  padding: 16px;
  text-align: center;
  font-size: 12px;
  color: var(--text-muted, #64748b);
}`, "",{"version":3,"sources":["webpack://./src/components/SearchableSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;EACxC,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,mCAAmC;EACnC,wCAAwC;EACxC,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,oCAAoC;EACpC,wCAAwC;EACxC,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,mCAAmC;EACnC,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wDAAwD;EACxD,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iCAAiC;EACjC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC","sourcesContent":[".ss-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.ss-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 12px;\n  background: var(--bg-input, #0f172a);\n  border: 1px solid var(--border, #1e293b);\n  border-radius: var(--radius-sm, 6px);\n  cursor: pointer;\n  min-height: 36px;\n  font-size: 13px;\n  color: var(--text-primary, #f0f2f5);\n  transition: border-color 0.15s;\n}\n\n.ss-trigger:hover {\n  border-color: var(--accent, #6366f1);\n}\n\n.ss-value {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ss-sublabel {\n  font-size: 11px;\n  color: var(--text-muted, #64748b);\n  font-family: var(--font-mono, monospace);\n}\n\n.ss-placeholder {\n  color: var(--text-muted, #64748b);\n}\n\n.ss-actions {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.ss-clear {\n  background: none;\n  border: none;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  padding: 2px;\n  display: flex;\n  align-items: center;\n  border-radius: 3px;\n}\n\n.ss-clear:hover {\n  color: var(--danger, #ef4444);\n  background: var(--bg-secondary, #1a2035);\n}\n\n.ss-chevron {\n  color: var(--text-muted, #64748b);\n  transition: transform 0.15s;\n}\n\n.ss-chevron.open {\n  transform: rotate(180deg);\n}\n\n.ss-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: var(--bg-card, #1a2035);\n  border: 1px solid var(--border, #1e293b);\n  border-radius: var(--radius-sm, 6px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 1000;\n  max-height: 320px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.ss-search {\n  position: relative;\n  padding: 8px;\n  border-bottom: 1px solid var(--border, #1e293b);\n}\n\n.ss-search-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted, #64748b);\n}\n\n.ss-search-input {\n  width: 100%;\n  padding: 6px 10px 6px 30px;\n  background: var(--bg-input, #0f172a);\n  border: 1px solid var(--border, #1e293b);\n  border-radius: 4px;\n  color: var(--text-primary, #f0f2f5);\n  font-size: 12px;\n  outline: none;\n}\n\n.ss-search-input:focus {\n  border-color: var(--accent, #6366f1);\n}\n\n.ss-options {\n  overflow-y: auto;\n  max-height: 260px;\n}\n\n.ss-option {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 12px;\n  color: var(--text-primary, #f0f2f5);\n  border-bottom: 1px solid var(--border, #1e293b);\n  transition: background 0.1s;\n}\n\n.ss-option:last-child {\n  border-bottom: none;\n}\n\n.ss-option:hover {\n  background: var(--bg-secondary, #0f172a);\n}\n\n.ss-option.selected {\n  background: var(--accent-soft, rgba(99, 102, 241, 0.15));\n  color: var(--accent, #6366f1);\n}\n\n.ss-option-empty {\n  font-style: italic;\n  color: var(--text-muted, #64748b);\n}\n\n.ss-option-label {\n  font-weight: 500;\n}\n\n.ss-option-sublabel {\n  font-size: 10px;\n  color: var(--text-muted, #64748b);\n  font-family: var(--font-mono, monospace);\n  margin-top: 2px;\n}\n\n.ss-no-results {\n  padding: 16px;\n  text-align: center;\n  font-size: 12px;\n  color: var(--text-muted, #64748b);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
